import { PopoverProps } from 'antd/lib/popover'
import { MemberProps } from 'app/components/Core/convention'
import KInfo from 'app/components/Modules/DataDisplay/KInfo'
import KPopover from 'app/components/UI-Elements/DataDisplay/KPopover'
import { RecordType } from 'app/constants/GlobalTypes'
import * as React from 'react'

import { ISchedulerLineItem } from './Scheduler'

const Popover: React.FC<MemberProps<ISchedulerLineItem, PopoverProps>> = ({
  member,
  props = {}
}) => {
  const { project_name, start_date, return_date, rentalCode } = member
  const info = { rental_code: rentalCode, dates: `${start_date} - ${return_date}` }
  return (
    <KPopover
      title={project_name}
      content={<KInfo recordType={RecordType.line_item} member={{ ...info }} />}
      overlayClassName={'popover-list-container'}
      {...props}
    />
  )
}

export default Popover
